import { render, staticRenderFns } from "./FAQCategoryList.vue?vue&type=template&id=2d17738c"
import script from "./FAQCategoryList.vue?vue&type=script&lang=js"
export * from "./FAQCategoryList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports